module.exports = __webpack_public_path__ + "img/joinWRImg1.9479e55b.png";